import { useState } from 'react'
import { AlertCircle } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import Button from '../../components/Button'
import TextField from '../../components/TextField'
import { grantAccess } from './installService'
import { LOGO_SRC } from './assets'
import { strings as S } from './strings'
import './AccessGate.css'

/**
 * Replaces the legacy `prompt("Please enter the access code:")` that guards
 * Install/Index. Cancelling goes to Login, exactly as the legacy script did.
 */
export default function AccessGate({ onGranted }) {
  const navigate = useNavigate()
  const [passkey, setPasskey] = useState('')
  const [denied, setDenied] = useState(false)
  const [checking, setChecking] = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setChecking(true)
    setDenied(false)

    const { result } = await grantAccess(passkey)

    if (result) {
      onGranted()
    } else {
      setDenied(true)
      setPasskey('')
      setChecking(false)
    }
  }

  return (
    <div className="access-gate">
      <form className="access-gate__card" onSubmit={handleSubmit}>
        <img className="access-gate__logo" src={LOGO_SRC} alt={S.logoAlt} />

        <div className="access-gate__body">
          <label className="access-gate__label" htmlFor="access-code">
            <bdi>{S.accessGate.prompt}</bdi>
          </label>

          <TextField
            id="access-code"
            type="password"
            value={passkey}
            onChange={setPasskey}
            autoComplete="off"
            autoFocus
          />

          {denied && (
            <p className="access-gate__error" role="alert">
              <AlertCircle size={16} aria-hidden="true" />
              <bdi>{S.accessGate.denied}</bdi>
            </p>
          )}

          <div className="access-gate__actions">
            <Button variant="ghost" onClick={() => navigate('/login')}>
              {S.accessGate.cancel}
            </Button>
            <Button type="submit" variant="primary" disabled={checking || passkey === ''}>
              {S.accessGate.confirm}
            </Button>
          </div>
        </div>
      </form>
    </div>
  )
}
